import React, { useState } from "react";
import { AddToCartAndDeliveryPointModals } from "./DeliveryPointAndAddArticleToCartModals";
import { ProductDetailFeature } from "./ProductDetailFeature";
import {ModalCantEditOrderWhenItsNotInInitialState} from "./ModalCantEditOrderWhenItsNotInInitialState";

export default function AddProductToCartButton({ productId, application, navigator, deliverySiteFeature }) {
    const [productFeature, setProductFeature] = useState(null);
    const [addToCartModalOpen, setAddToCartModalOpen] = useState(false);

    const handleClick = async () => {
        const feature = new ProductDetailFeature(application, productId);
        await feature.load();
        setProductFeature(feature);

        if (!deliverySiteFeature.isDeliveryPointModalOpened) {
            setAddToCartModalOpen(true);
        }
    };

    return (
        <>
            <a className="btn btn-primary btn-sm btn-outlined" onClick={handleClick}>
                Añadir
            </a>

            {productFeature?.loaded && (
                <>
                    <AddToCartAndDeliveryPointModals
                        addToCartModalOpen={addToCartModalOpen}
                        setAddToCartModalOpen={setAddToCartModalOpen}
                        productFeature={productFeature}
                        deliverySiteFeature={deliverySiteFeature}
                        navigator={navigator}
                    />

                    <ModalCantEditOrderWhenItsNotInInitialState
                        open={productFeature.isModalCantEditOrderOpened}
                        feature={productFeature}
                    />
                </>
            )}
        </>
    );

}
